import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VmeJobsInboxComponent } from './vme-jobs-inbox.component';

const routes: Routes = [
  {
    path: '',
    component: VmeJobsInboxComponent,
    data: { title: 'Inbox', reuseRoute: false, scrollToTop: true },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VmeJobsInboxRoutingModule {}

@NgModule({
  imports: [
    VmeJobsInboxRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [VmeJobsInboxComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VmeJobsInboxModule {}
